import React from 'react';
import moment from 'moment';
import PlaceholderLogo from '../../../assets/placeholderLogo.png';
import JsonSchema from '../../../components/JsonSchema';

const ProductSchema = ({ reviewAggregates, meta, reviews }) => {
  const { count, averageRating } = reviewAggregates || {};
  const productSchema = () => {
    const { category, description } = meta || {};
    const schema = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      name: category,
      description: description || category,
      image: PlaceholderLogo,
      brand: {
        '@type': 'Brand',
        name: 'Localsearch',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        reviewCount: count,
        ratingCount: count,
        ratingValue: averageRating,
        worstRating: 1,
        bestRating: 5,
      },
      reviews: reviews.map(
        ({ displayName, updatedAt, message, rating, listing: { name } }) => {
          return {
            '@type': 'Review',
            author: displayName || 'Anonymous',
            datePublished: moment(updatedAt).format('YYYY-MM-DD'),
            description: message || '',
            name: `Review for ${name}`,
            reviewRating: {
              '@type': 'Rating',
              ratingValue: rating,
            },
          };
        }
      ),
    };

    return schema;
  };
  if (count > 0) return <>{JsonSchema(productSchema())}</>;
  return '';
};

export default ProductSchema;
